// Hitungan paging murni (tanpa DOM) biar gampang diuji & jadi satu sumber kebenaran.
// Balikin window slice [start, end) buat halaman aktif yang udah di-clamp.
// .mjs biar bisa di-import langsung sama node buat self-check (lihat devTools/paginate.check.mjs).
export default function paginate(total, rowsPerPage, currentPage) {
  const size = Math.max(1, rowsPerPage);
  const totalPages = total > 0 ? Math.ceil(total / size) : 0;
  const maxPage = Math.max(0, totalPages - 1);
  const safePage = Math.min(maxPage, Math.max(0, currentPage || 0));
  const start = safePage * size;
  const end = Math.min(start + size, Math.max(0, total));
  return {
    start,
    end,
    totalPages,
    safePage,
  };
}
